// import axios from "axios";
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./SchoolNewClass.css";

// const SchoolNewClass = () => {
//   const [schoolClassName, setSchoolClassName] = useState("");
//   const [category, setCategory] = useState([]);
//   const [selectCategory, setSelectCategory] = useState("");

//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   const handleAddCategory = () => {
//     if (selectCategory && !category.includes(selectCategory)) {
//       setCategory([...category, selectCategory]);
//       setSelectCategory(""); // reset dropdown
//     }
//   };

//   const handleRemoveCategory = (cat) => {
//     setCategory(category.filter((item) => item !== cat));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     axios
//       .post(`${API_BASE_URL}/classes`, {
//         className: schoolClassName,
//         category: category,
//       })
//       .then((resp) => {
//         alert("Class Added Successfully!");
//         schoolClassName("");
//         category("");
//         // navigate("/school-add-class");
//       })
//       .catch((err) => {
//         alert("Error adding class.");
//         console.log(err);
//       });
//   };

//   const handleAddNewClass = () => {
//     navigate("/school-add-class");
//   };

//   const handleViewAllClasses = () => {
//     navigate("/school-all-class");
//   };
//   // console.log(category);

//   return (
//     <div id="add-department-inner-wrapper">
//       <div className="superheader">
//         <div className="departmetHeaderdiv">
//           <h5>Class</h5>
//           <div className="departmentdiv2">
//             <button className="handlenewclass" onClick={handleAddNewClass}>
//               + Add New Class
//             </button>
//             <button className="allclasses" onClick={handleViewAllClasses}>
//               All Classes
//             </button>
//           </div>
//         </div>

//         <div className="form-school-container">
//           <h4 className="department-detail">Class Details</h4>
//           <form onSubmit={handleSubmit} className="department-detail-form">
//             <div className="input-group">
//               <div style={{ paddingBottom: "10px" }}>
//                 <label className="label"> Class Name</label>
//               </div>
//               <input
//                 className="school-class-add-input-tag"
//                 type="text"
//                 value={schoolClassName}
//                 onChange={(e) => setSchoolClassName(e.target.value)}
//                 placeholder="Enter Class Name"
//                 required
//               />
//             </div>

//             <div className="input-group">
//               <div style={{ paddingBottom: "10px" }}>
//                 <label className="label">Select Category</label>
//               </div>
//               <div style={{ display: "flex", gap: "10px" }}>
//                 <select
//                   className="school-class-add-input-tag"
//                   value={selectCategory}
//                   onChange={(e) => setSelectCategory(e.target.value)}
//                 >
//                   <option value="">-Select Category-</option>
//                   <option
//                     value="Exam_Notes"
//                     disabled={category.includes("Exam_Notes")}
//                   >
//                     Exam Notes
//                   </option>
//                   <option
//                     value="Subjective_Exam"
//                     disabled={category.includes("Subjective_Exam")}
//                   >
//                     Subjective Exam
//                   </option>
//                   <option 
//                   value="video_section"
//                   disabled={category.includes("video_section")}
//                   >
//                     Video Section
//                   </option>
//                 </select>
//                 <button
//                   type="button"
//                   onClick={handleAddCategory}
//                   className="btn-s"
//                 >
//                   Add
//                 </button>
//               </div>
//             </div>

//             {/* Show selected categories with remove option */}
//             {category.length > 0 && (
//               <div className="selected-categories">
//                 <p style={{ marginBottom: "5px" }}>Selected Categories:</p>
//                 <ul>
//                   {category.map((cat, index) => (
//                     <li key={index} style={{ marginBottom: "5px" }}>
//                       {cat.replaceAll("_", " ")}
//                       <button
//                         type="button"
//                         onClick={() => handleRemoveCategory(cat)}
//                         style={{
//                           marginLeft: "10px",
//                           background: "red",
//                           color: "white",
//                           border: "none",
//                           padding: "2px 6px",
//                           borderRadius: "4px",
//                           cursor: "pointer",
//                         }}
//                       >
//                         Remove
//                       </button>
//                     </li>
//                   ))}
//                 </ul>
//               </div>
//             )}

//             <div className="form-school-btns">
//               <button className="btn-s" type="submit">
//                 Save
//               </button>
//               <button
//                 className="btn-c"
//                 type="button"
//                 onClick={() => navigate(-1)}
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default SchoolNewClass;







import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "./SchoolNewClass.css";

const SchoolNewClass = () => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  const [schoolClassName, setSchoolClassName] = useState("");
  const [boards, setBoards] = useState([]);
  const [selectedBoard, setSelectedBoard] = useState("");
  const [category, setCategory] = useState([]);
  const [selectCategory, setSelectCategory] = useState("");

  /* ================= FETCH BOARDS ================= */

  useEffect(() => {
    const fetchBoards = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/boards`,
          {
            headers: {
              Authorization:
                "Bearer " + localStorage.getItem("token"),
            },
          }
        );

        setBoards(response.data.data || response.data);
      } catch (error) {
        Swal.fire("Error", "Failed to fetch boards", "error");
      }
    };

    fetchBoards();
  }, []);

  /* ================= CATEGORY HANDLING ================= */

  const handleAddCategory = () => {
    if (selectCategory && !category.includes(selectCategory)) {
      setCategory([...category, selectCategory]);
      setSelectCategory("");
    }
  };

  const handleRemoveCategory = (cat) => {
    setCategory(category.filter((item) => item !== cat));
  };

  const handleAddNewClass = () => {
    navigate("/school-add-class");
  };
  const handleViewAllClasses = () => {
    navigate("/school-all-class");
  };

  /* ================= SUBMIT ================= */

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedBoard) {
      return Swal.fire("Warning", "Please select board", "warning");
    }

    if (category.length === 0) {
      return Swal.fire(
        "Warning",
        "Please select at least one category",
        "warning"
      );
    }

    try {
      await axios.post(
        `${API_BASE_URL}/classes`,
        {
          className: schoolClassName,
          board: selectedBoard,
          category: category,
        },
        {
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      await Swal.fire(
        "Success",
        "Class added successfully!",
        "success"
      );

      // Reset form
      setSchoolClassName("");
      setSelectedBoard("");
      setCategory([]);
      setSelectCategory("");

      navigate("/school-all-class");

    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.msg || "Error adding class",
        "error"
      );
    }
  };

  return (
    <div id="add-department-inner-wrapper">
      <div className="superheader">
        <div className="departmetHeaderdiv">
          <h5>Class</h5>
        </div>

        <div className="form-school-container">
          <h4 className="department-detail">Class Details</h4>
          <div className="classes-header-btns">
            <button className="add-class-btn" onClick={handleAddNewClass}>
              + Add New Class
            </button>
            <button className="all-classes-btn" onClick={handleViewAllClasses}>
              All Classes
            </button>
          </div>

          <form onSubmit={handleSubmit} className="department-detail-form">

            {/* CLASS NAME */}
            <div className="input-group">
              <label className="label">Class Name</label>
              <input
                className="school-class-add-input-tag"
                type="text"
                value={schoolClassName}
                onChange={(e) =>
                  setSchoolClassName(e.target.value)
                }
                placeholder="Enter Class Name"
                required
              />
            </div>

            {/* BOARD DROPDOWN */}
            <div className="input-group">
              <label className="label">Select Board</label>
              <select
                className="school-class-add-input-tag"
                value={selectedBoard}
                onChange={(e) =>
                  setSelectedBoard(e.target.value)
                }
                required
              >
                <option value="">-Select Board-</option>
                {boards.map((board) => (
                  <option key={board._id} value={board._id}>
                    {board.boardName}
                  </option>
                ))}
              </select>
            </div>

            {/* CATEGORY */}
            <div className="input-group">
              <label className="label">Select Category</label>
              <div style={{ display: "flex", gap: "10px" }}>
                <select
                  className="school-class-add-input-tag"
                  value={selectCategory}
                  onChange={(e) =>
                    setSelectCategory(e.target.value)
                  }
                >
                  <option value="">-Select Category-</option>
                  <option
                    value="Exam_Notes"
                    disabled={category.includes("Exam_Notes")}
                  >
                    Exam Notes
                  </option>
                  <option
                    value="Subjective_Exam"
                    disabled={category.includes(
                      "Subjective_Exam"
                    )}
                  >
                    Subjective Exam
                  </option>
                  <option
                    value="video_section"
                    disabled={category.includes(
                      "video_section"
                    )}
                  >
                    Video Section
                  </option>
                </select>

                <button
                  type="button"
                  onClick={handleAddCategory}
                  className="btn-s"
                >
                  Add
                </button>
              </div>
            </div>

            {/* SELECTED CATEGORY LIST */}
            {category.length > 0 && (
              <div className="selected-categories">
                <p>Selected Categories:</p>
                <ul>
                  {category.map((cat, index) => (
                    <li key={index}>
                      {cat.replaceAll("_", " ")}
                      <button
                        type="button"
                        onClick={() =>
                          handleRemoveCategory(cat)
                        }
                        className="remove-btn"
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* BUTTONS */}
            <div className="form-school-btns">
              <button className="btn-s" type="submit">
                Save
              </button>
              <button
                className="btn-c"
                type="button"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
            </div>

          </form>
        </div>
      </div>
    </div>
  );
};

export default SchoolNewClass;